module.exports = __webpack_public_path__ + "static/media/WITHOUT_LABLES.07b62c03.svg";